import React from 'react';
import ReactDOM from 'react-dom';
import DashboardMedicationCard from '../components/dashboard-medications/dashboard-medication-card.jsx';
import Dashboard from '@js/dashboard.es6.js';
import Accordion from 'accordion-js';
import {LuminisServiceUtils} from '@js/utils/utils-imports.es6.js';

export default class DashboardMedicationContainer {
  constructor() {
    this.dashboard = new Dashboard();
    this.luminisServiceUtils = new LuminisServiceUtils();
  }

  async initContainer() {
    const medicationJson = await this.luminisServiceUtils.getPatientMedications();

    if (medicationJson && medicationJson.length > 0) {
      // get link from twig template
      const medicationSelector = document.querySelector(
        '.field--name-field-view-all-medication-detail',
      );

      if (medicationSelector) {
        const medicationLink = medicationSelector.outerHTML;
        const viewDetailsUrl = medicationLink.href;
        const viewDetailsText = medicationLink.innerHTML;

        try {
          ReactDOM.render(
            <>
              {medicationJson.map(medication => {
                return (
                  <DashboardMedicationCard
                    key={medication.name}
                    name={medication.name}
                    patientSig={medication.patientSig}
                    viewDetailsUrl={viewDetailsUrl}
                    viewDetailsText={viewDetailsText}
                    viewDetailsHTML={medicationLink}
                  />
                );
              })}
            </>,
            document.querySelector('.medication-container'),
          );
          document.querySelector('.medications .loading-box').classList.toggle('hidden');
          document.querySelector('.medication-container').classList.toggle('hidden');
          this.setListeners();
          return;
        } catch (e) {
          // purposefully empty
        }
      }
    }

    document.querySelector('.medications .loading-box').classList.toggle('hidden');
    document.querySelector('.no-medications-container').classList.toggle('hidden');
    document.querySelector('.view-all-medications-link--mobile').classList.toggle('hidden');
    document.querySelector('.view-all-medications-link--desktop').classList.toggle('hidden');
  }

  setListeners() {
    this.accordion = new Accordion('.medication-container', {
      collapse: true,
      duration: 250,
    });
    this.accordion.closeAll();
    this.accordion.open(0);
  }
}

(() => {
  if (document.querySelector('.node--type-dashboard .medication-container')) {
    const dashboardDedicationContainer = new DashboardMedicationContainer();
    dashboardDedicationContainer.initContainer();
  }
})(Drupal);
